module.exports = __webpack_public_path__ + "static/img/logo.d6da3fc3.png";